
import { Helmet } from 'react-helmet';
import HeroSection from '@/components/HeroSection';
import TestimonialSection from '@/components/TestimonialSection';
import BookInsightsSection from '@/components/BookInsightsSection';
import BreakthroughSection from '@/components/BreakthroughSection';
import BookOfferSection from '@/components/BookOfferSection';
import AuthorSection from '@/components/AuthorSection';
import { Separator } from '@/components/ui/separator';
import BonusesSection from '@/components/BonusesSection';
import FAQSection from '@/components/FAQSection';
import LimitedOfferSection from '@/components/LimitedOfferSection';
import FooterSection from '@/components/FooterSection';

const Index = () => {
  return (
    <>
      <Helmet>
        <title>The Liberated Consultant: Free Book for Becoming an Independent ERP Consultant</title>
        <meta name="description" content="Get your FREE copy of The Liberated Consultant by Rey Marques. Learn how to double your income, work half the year, and invest in your dreams." />
      </Helmet>
      
      <div className="min-h-screen bg-book-lightBg">
        <HeroSection />
        <TestimonialSection />
        <BreakthroughSection />
        <BookInsightsSection />
        <BookOfferSection />
        <AuthorSection />
        <div className="container mx-auto px-4 py-8">
          <Separator className="h-1 bg-gradient-to-r from-book-yellow/20 via-book-yellow to-book-yellow/20 rounded-full" />
        </div>
        <BonusesSection />
        <FAQSection />
        <LimitedOfferSection />
        <FooterSection />
      </div>
    </>
  );
};

export default Index;
